import { clsx } from "clsx";
import { Info } from "lucide-react";
import { useTranslations } from "../../i18n";
import { cloneWithClassName } from "../../utils";
import { IconButton } from "../Button/IconButton";
import { Text } from "../Text";
import { Tooltip } from "../Tooltip";
import type { ICardHeaderProps } from "./types";

export const CardHeader = ({
  icon,
  title,
  tooltipProps,
  className,
  children,
}: ICardHeaderProps) => {
  const { t } = useTranslations();

  return (
    <div className={clsx("nuco-card__header", className)}>
      {icon && <div className="nuco-card__icon">{icon}</div>}
      {cloneWithClassName(title, "nuco-card__title") || (
        <Text size="lg" weight="bold" className="nuco-card__title">
          {title}
        </Text>
      )}
      {tooltipProps && (
        // A focusable trigger, so keyboard users can open the tooltip too.
        <Tooltip {...tooltipProps}>
          <IconButton
            variant="ghost"
            color="neutral"
            size="xs"
            className="nuco-card__info"
            aria-label={t("ui.card.moreInfo")}
          >
            <Info />
          </IconButton>
        </Tooltip>
      )}
      {children && <div className="nuco-card__header-end">{children}</div>}
    </div>
  );
};
